import Lockr from 'lockr';
import Vue, { hookRouter, i18n } from './common';
import router from './router/interview';
import store from './store';
import App from './App';
import '@/assets/css/common-pc.css';
import '@/assets/css/global-style.css';
import '@/assets/css/interview.css';
import { sendLoginInfo, linkInterview } from '@/utils/interviewSocket';

window.Hls = require('hls.js');

hookRouter(router, (userInfo) => {
  linkInterview().then((ws) => {
    sendLoginInfo(ws, userInfo);
    Vue.prototype.$ws = ws;
  });
});

i18n.locale = Lockr.get('local');

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App }
});
